import { useMemo } from 'react';

import { workspaceApi } from '@/api/workspace/index.ts';
import { useAppStore } from '@/store/hooks.ts';
import { saveCurrentSharedTab } from '@/store/sharedWorkspace/saveCurrentSharedTab.ts';

const CACHE_KEY = 'use-save-current-shared-tab-cacahe-key';

export function useSaveCurrentSharedTab() {
  const { getState, dispatch } = useAppStore();

  const [_, infos] = workspaceApi.endpoints.shareTab.useMutation({ fixedCacheKey: CACHE_KEY });

  return useMemo(
    () => [() => saveCurrentSharedTab({ getState, dispatch, cacheKey: CACHE_KEY }), infos] as const,
    [getState, dispatch, infos],
  );
}
